import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Handshake, Sparkles } from 'lucide-react';
import { AuthModal } from '../components/AuthModal';
import { Logo } from '../components/Logo';

// Landing d'inscription référée : /register?referral=PROM-XXXX-0000&leadId=...
// Stocke le code + leadId en sessionStorage (lus par AuthModal à l'inscription),
// affiche une mention du parrain (prénom seulement) et ouvre le signup organisateur.
export default function RegisterPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const referral = params.get('referral') || '';
  const leadId = params.get('leadId') || '';

  const [invite, setInvite] = useState<{ promoterFirstName: string; festivalName: string } | null>(null);

  useEffect(() => {
    if (referral) sessionStorage.setItem('festin_referral', referral);
    if (leadId) sessionStorage.setItem('festin_leadId', leadId);
    // On force le rôle organisateur pour un lead promoteur.
    // localStorage : doit survivre à une éventuelle redirection Google mobile.
    localStorage.setItem('pendingSignupRole', 'festival');
  }, [referral, leadId]);

  useEffect(() => {
    async function loadInvite() {
      if (!leadId) return;
      try {
        const resp = await fetch(`${import.meta.env.VITE_API_URL || ''}/api/promoter-leads/${leadId}/invite`);
        if (resp.ok) {
          const j = await resp.json();
          if (j.found) setInvite({ promoterFirstName: j.promoterFirstName || '', festivalName: j.festivalName || '' });
        }
      } catch { /* noop */ }
    }
    loadInvite();
  }, [leadId]);

  return (
    <div className="min-h-screen bg-[#0D0D0F] text-white flex flex-col items-center justify-center px-6 relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-[#FF5C00] opacity-10 blur-[140px] rounded-full pointer-events-none" />

      <div className="relative text-center max-w-md mb-8">
        <button onClick={() => navigate('/')} className="inline-block mb-8"><Logo /></button>
        <div className="inline-flex items-center gap-2 bg-[#FF5C00]/10 border border-[#FF5C00]/20 text-[#FF5C00] text-xs font-black px-3 py-1.5 rounded-full mb-5">
          <Handshake className="w-3.5 h-3.5" /> INVITATION
        </div>
        <h1 className="text-3xl font-black tracking-tight mb-3">Bienvenue sur Festin</h1>
        {invite?.promoterFirstName ? (
          <p className="text-gray-400 leading-relaxed">
            Votre inscription a été initiée par <strong className="text-white">{invite.promoterFirstName}</strong>.
            {invite.festivalName && <> Créez votre profil pour publier <strong className="text-white">{invite.festivalName}</strong>.</>}
          </p>
        ) : (
          <p className="text-gray-400 leading-relaxed">Créez votre compte organisateur pour publier votre festival et recevoir des candidatures d'exposants.</p>
        )}
        {referral && (
          <div className="inline-flex items-center gap-2 mt-4 bg-white/5 border border-white/10 text-gray-400 text-xs font-medium px-3 py-1.5 rounded-full">
            <Sparkles className="w-3 h-3 text-[#FF5C00]" /> Parrainage appliqué
          </div>
        )}
      </div>

      {/* Modale d'inscription ouverte d'emblée, rôle organisateur */}
      <AuthModal isOpen={true} onClose={() => navigate('/')} initialMode="signup" role="festival" />
    </div>
  );
}
